var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurntableRotationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.722 10.2014C20.1165 11.0005 21 12.0503 21 13.2C21 15.1025 18.6456 16.7313 15.361 17.4038M9.75934 17.5905C5.89367 17.0873 3 15.3124 3 13.2C3 12.0503 3.88349 11.0006 5.27801 10.2014M12 13.2L7.51867 10.9333V5.26667M12 13.2V7.53333M12 13.2L16.4813 10.9333V5.26667M7.51867 5.26667L12 7.53333M7.51867 5.26667L12 3L16.4813 5.26667M12 7.53333L16.4813 5.26667M9.75934 15.4667V20L13.1203 17.7333L9.75934 15.4667Z",
    stroke: "#88919A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurntableRotationIcon);
export default __webpack_public_path__ + "static/media/TurntableRotationIcon.0fa0ec69939ffd3b9b1c40793fbca126.svg";
export { ForwardRef as ReactComponent };